import React from 'react';

import {AlertActions, AlertModal} from 'presentation/components';
import {useMediaQueries} from 'presentation/pages/private/hooks';
import {translations} from 'presentation/translations-new';
import {BookingNotFoundDialogProps} from './types';
import {getNotFoundContent} from './utils/getNotFoundContent';

const {chatOnline} = translations['pt-br'].privateFlow.bookingFlow;

export function BookingNotFoundDialog({
	variant,
	handleCallChatRoom,
	handleGuideNav,
	open,
	setOpen,
	flowType,
	firstActionDataTagId,
	secondActionDataTagId,
	headerModalDataTagId,
	closeModalDataTagId,
	callChatRoomIsLoading,
}: BookingNotFoundDialogProps) {
	const {isMobile} = useMediaQueries();

	const content = getNotFoundContent({variant, flowType});

	return (
		<AlertModal
			headerDataTagId={headerModalDataTagId}
			closeBtnDataTagId={closeModalDataTagId}
			slotProps={{
				paper: {
					style: {
						maxWidth: 420,
						margin: isMobile ? 16 : 'auto',
						flex: isMobile ? 1 : 'initial',
					},
				},
			}}
			footerContent={
				<AlertActions
					primaryAction={() => handleGuideNav(flowType)}
					dataTagId={firstActionDataTagId}
					secondaryBtnDataTagId={secondActionDataTagId}
					secondaryAction={handleCallChatRoom}
					isLoadingSecondary={callChatRoomIsLoading}
					isDisabledSecondary={callChatRoomIsLoading}
					secondaryText={chatOnline}
					primaryText={content.modalActionButton}
					flexDirection="column-reverse"
				/>
			}
			description={content.description}
			headerTitle={content.headerTitle}
			onClose={() => setOpen(false)}
			title={content.title}
			open={open}
			variant="primary"
		/>
	);
}
